import { makeStyles } from '@mui/styles';

const linkDisplayStyles = makeStyles(() => ({
    modalContainer: {
        position: 'absolute',
        backgroundColor: 'white',
        top: `50%`,
        left: `50%`,
        transform: `translate(-50%, -50%)`,
        '&:focus': {
            outline: 'none',
        },
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        borderRadius: '5px',
        boxShadow: '0 0 5px #444444',
        padding: '45px 20px 20px',
        width: '85%',
        height: '90%',
        '& .react-transform-wrapper': {
            width: '100%',
            height: '100%',
            maxHeight: '80vh',
        },
        '& .react-transform-component': {
            width: '100%',
            height: '80vh',
            justifyContent: 'center',
            alignItems: 'center',
        },
    },
    embedContainer: {
        position: 'relative',
        width: '100%',
        height: '100vw',
        maxHeight: 'calc(100vh - 180px)',
        overflow: 'auto',
        '& iframe': {
            position: 'absolute',
            top: '0',
            left: '0',
            width: '100%',
            height: '100%',
            border: '0',
        },
    },
    imageContainer: {
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        maxHeight: 'calc(100vh - 180px)',
        overflow: 'auto',
        height: '100vw',
        '& div': {
            position: 'absolute',
            paddingBottom: '10px',
        },
    },
    imageZoomButtons: {
        position: 'absolute',
        cursor: 'pointer',
        top: '19px',
        left: '19px',
        background: '#ffffff',
        // padding: '0.5rem',
        boxShadow: 'none',
        zIndex: '3',
        '& div': {
            position: 'absolute',
            padding: '5px',
            '& svg': {
                color: 'white',
                width: '25px',
                height: '25px',
            },
        },
    },
    zoomButton: {
        borderRadius: '6px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: (props) => props.colors.button.primaryBackground,
        marginTop: '3rem',
        marginLeft: '1rem',
    },
    videoContainer: {
        position: 'relative',
        width: '100%',
        height: '100vw',
        maxHeight: 'calc(100vh - 180px)',
        overflow: 'auto',
        marginBottom: '10px',
        '& video': {
            position: 'absolute',
            top: '0',
            left: '0',
            width: '100%',
            maxHeight: 'calc(100vh - 180px)',
            paddingBottom: '10px',
        },
    },
    close: {
        marginTop: 'auto',
        width: '100%',
        background: (props) => props.colors.button.primaryBackground,
        color: (props) => props.colors.button.primaryForeground,
        '&:hover': {
            background: (props) => props.colors.button.primaryBackground,
            color: (props) => props.colors.button.primaryForeground,
            filter: 'brightness(90%)',
        },
        alignSelf: 'bottom',
    },
    displayOptionsMenu: {
        background: (props) => props.colors.button.primaryBackground,
        display: 'flex',
        gap: '5px',
        border: '1px solid #fff',
        padding: '5px',
        borderRadius: '5px',
        '& > button': {
            width: '30px',
            height: '30px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: '3px',
            border: '1px solid #fff',
        },
    },
    chaptersWrapper: {
        display: 'flex',
        flexDirection: 'column',
        width: '190px',
        overflow: 'auto',
        alignItems: 'center',
        // height: 'calc(100vh - 180px)',
        '&::-webkit-scrollbar': {
            height: '6px',
            width: '6px',
            backgroundColor: '#F5F5F5',
        },
        '&::-webkit-scrollbar-track': {
            '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.3)',
            backgroundColor: '#F5F5F5',
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#a4a4a4',
        },
    },
    chapterButtonText: {
        display: 'inline-block',
        overflow: 'hidden',
        WebkitBoxOrient: 'vertical',
        WebkitLineClamp: 2,
        fontSize: 'inherit',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    chaptersLabel: {
        width: '150px',
        minWidth: '150px',
        backgroundColor: '#000000',
        borderRadius: '4px',
        padding: '5px',
        color: '#FFFFFF',
        fontWeight: '600',
        position: 'sticky',
        top: '0px',
        zIndex: 2,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    chaptersCollapseButton: {
        zIndex: 9,
        position: 'absolute !important',
        color: '#fff !important',
        borderRadius: '4px !important',
    },
    chaptersButton: {
        backgroundColor: (props) => `${props.colors.chapter_button.background_color} !important`,
        color: (props) => `${props.colors.chapter_button.text_color} !important`,
        '&:hover': {
            filter: 'brightness(90%)',
        },
        width: '150px',
        maxWidth: '150px',
        border: '1px solid #ffffff',
        '&.chaptersActive': {
            backgroundColor: (props) => `${props.colors.chapter_button.active_color} !important`,
            color: (props) => `${props.colors.chapter_button.text_color} !important`,
            '&:hover': {
                filter: 'brightness(90%)',
            },
        },
    },
    activeChapterButton: {
        backgroundColor: (props) => `${props.colors.chapter_button.active_color} !important`,
        color: (props) => `${props.colors.chapter_button.text_color} !important`,
        '&:hover': {
            filter: 'brightness(90%)',
        },
    },
    overlayText: {
        zIndex: 2,
        top: '20px',
        left: '70px',
        position: 'absolute',
        width: '100%',
        height: 'auto',
        userSelect: 'none',
    },
    linkTitleWrapper: {
        backgroundColor: 'rgb(0 0 0 / 60%)',
        color: '#fff',
        width: '100%',
        minHeight: '38px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'absolute',
        top: '0',
        zIndex: '9',
    },
    linkTitleText: {
        padding: '5px',
        fontWeight: '600',
        fontSize: '18px',
        maxWidth: '50%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    linkIndex: {
        padding: '5px 10px',
        fontWeight: '600',
        fontSize: '18px',
    },
    navigationButtonWrapper: {
        width: '100%',
        position: 'absolute',
        zIndex: '9',
    },
    navigationButton: {
        pointerEvents: 'all',
        backgroundColor: '#0009',
        borderRadius: '5px',
        color: '#fff',
        width: '30px',
        height: '30px',
        position: 'absolute',
        '&:hover': {
            backgroundColor: '#c4c4c4',
            color: '#000',
        },
        '&:disabled': {
            display: 'none',
        },
    },
}));

export { linkDisplayStyles };
